<template>
    <div class="card" style="width: 16rem; border-bottom-left-radius: 20px !important; border-bottom-right-radius: 20px !important;">
  <img :src="this.image" class="img_sizing card-img-top" alt="...">
  <div class="card-body product-body">
    <p class="cart-total">${{this.price}}</p>
    <h5 class="no_overflow card-title">{{ this.title }}</h5>
    <p class="no_overflow card-text">{{ this.description }}</p>
  </div>
</div>
</template>

<script>
export default{
    name:"ProductCard",
    props: {
    title: String,
    description: String,
    image: String,
    price: Number
  },
  methods:{
    displayModal(){
      console.log("hello")
    }
  }
}
</script>

<style scoped>
.no_overflow{
    white-space: nowrap;         /* Prevents line breaks */
  overflow: hidden;            /* Hides overflow text */
  text-overflow: ellipsis; 
}
.img_sizing{
    height: 200px;
}
.product-body{
  background-color: orange !important;
  color: white !important;
  overflow: hidden !important;
  border-bottom-right-radius: 20px !important;
  border-bottom-left-radius: 20px !important;

}
.cart-total{
  position: absolute;
  top: -23px;
  left: 200px !important;
  width: 80px;
  height: 80px;
  background-color: orange;
  color: white;
  border: solid yellow 2px;
  border-radius: 50%;
  text-align: center;

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>